import React, { ReactNode } from 'react'
import 'src/components/shared/StatusTag.css'
import { formatRelayStatus } from 'src/constants/ConversionUtils'
import { ArrowUturnLeftIcon, CheckCircleIcon, TruckIcon, XCircleIcon } from '@heroicons/react/24/outline'

type props = {
  status: string
  iconOnly?: boolean
}

const StatusTag: React.FC<props> = ({ status, iconOnly = false }) => {
  return (
    <div className="status-wrapper">
      <div className={`status-pill ${status}`}>
        {statusIconMap[status]}
        {!iconOnly && (
          <span>{formatRelayStatus(status)}</span>
        )}
      </div>
    </div>
  )
}
const statusIconMap: Record<string, ReactNode> = {
  'completed': <CheckCircleIcon/>,
  'in_transit': <TruckIcon />,
  'refunded': <ArrowUturnLeftIcon />,
  'failed_and_not_recoverable': <XCircleIcon />
}

export default StatusTag
